/* unplugin-vue-components disabled */import { render } from "./like_project.vue?vue&type=template&id=4183bebe&scoped=true"
import script from "./like_project.vue?vue&type=script&lang=js"
export * from "./like_project.vue?vue&type=script&lang=js"

import "./like_project.vue?vue&type=style&index=0&id=4183bebe&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4183bebe"]])

export default __exports__